import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";

const useCanSeeQuizStandards = () => {
  const { data: user } = useUser();
  const {
    activeELALicense,
    activeScienceLicense,
    activeSSLicense,
    isAuthorizedDistrictAdmin,
    isAuthorizedTeacher,
    isFreeUser,
    isStudent,
    hasAccessToLite,
  } = getUserProperties(user);

  if (hasAccessToLite) return !isStudent;

  const isAuthorizedUser =
    isAuthorizedTeacher && !isFreeUser && !isAuthorizedDistrictAdmin;

  const hasOnlyElaLicense =
    activeELALicense && !activeScienceLicense && !activeSSLicense;
  const hasElaAndScienceLicense = activeELALicense && activeScienceLicense;
  const hasElaAndSocialStudiesLicense = activeELALicense && activeSSLicense;
  const hasElaAndScienceAndSocialStudiesLicense =
    activeELALicense && activeScienceLicense && activeSSLicense;

  const hasAuthorizedLicense =
    hasOnlyElaLicense ||
    hasElaAndScienceLicense ||
    hasElaAndSocialStudiesLicense ||
    hasElaAndScienceAndSocialStudiesLicense;

  return isAuthorizedUser && hasAuthorizedLicense;
};

export default useCanSeeQuizStandards;
